interface Timestamp {
  toDate(): Date
}

export const formatDate = (date: Date | Timestamp, locale: string, today=new Date()): string => {
  if(!date) return ''

  // convert Timestamp to Date if necessary
  date = (date as Timestamp).toDate ? (date as Timestamp).toDate() : date as Date

  const isThisYear = today && date.getFullYear() === today.getFullYear()

  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: isThisYear ? undefined : '2-digit',
  }

  return new Intl.DateTimeFormat(locale, options).format(date)
}
